/** 获得考核期 */

const currentAssessDate=function(num){
    let myDate=new Date('2020/01/19'),
        y=myDate.getFullYear(),
        m=myDate.getMonth(),
        d=myDate.getDate();
    if(num) m+=1;
    let startY=y,
        startM=m;
    if(d<=20){
        startM=startM-1;
        if(m == 0){     //次年
            startY=startY-1;
            startM=12;
        }
    }else{
        m=m+1;
        if(m>=12){
            y+=1
        }
    }
    
    
    return `${startY}-${startM}-${21}/${y}-${m}-${20}`
}

const computeAssessDate = function(date=new Date()){
    let today = new Date(date);
    let zoneOffset = today.getTimezoneOffset();
    let GMTTime = today.getTime()+zoneOffset*(60*1000);
    let BJToday = new Date(GMTTime + (1000*60*60) * 8); // 北京时间
    let currentDate = BJToday.getDate();
    let currentMonth = BJToday.getMonth() + 1;
    let currentYear = BJToday.getFullYear();
    let prevCycle = '';
    let nextCycle = '';
    if(currentDate <= 20){
        if(currentMonth == 1){
            prevCycle = `${currentYear-1}-11-21/${currentYear-1}-12-20`;
            nextCycle = `${currentYear-1}-12-21/${currentYear}-01-20`;
        }else{
            if(currentMonth == 2){
				prevCycle = `${currentYear-1}-12-21/${currentYear}-${getTwoDigits(currentMonth-1)}-20`;
            	nextCycle = `${currentYear}-${getTwoDigits(currentMonth-1)}-21/${currentYear}-${getTwoDigits(currentMonth)}-20`;
			}else{
				prevCycle = `${currentYear}-${getTwoDigits(currentMonth-2)}-21/${currentYear}-${getTwoDigits(currentMonth-1)}-20`;
            	nextCycle = `${currentYear}-${getTwoDigits(currentMonth-1)}-21/${currentYear}-${getTwoDigits(currentMonth)}-20`;
			}
        }
    }else {
        if(currentMonth == 12){
            prevCycle = `${currentYear}-11-21/${currentYear}-12-20`;
            nextCycle = `${currentYear}-${getTwoDigits(currentMonth)}-21/${currentYear + 1}-01-20`;
        }else if (currentMonth == 1){
            prevCycle = `${currentYear-1}-12-21/${currentYear}-${getTwoDigits(currentMonth)}-20`;
            nextCycle = `${currentYear}-${getTwoDigits(currentMonth)}-21/${currentYear}-${getTwoDigits(currentMonth+1)}-20`;
        }else {
            prevCycle = `${currentYear}-${getTwoDigits(currentMonth-1)}-21/${currentYear}-${getTwoDigits(currentMonth)}-20`;
            nextCycle = `${currentYear}-${getTwoDigits(currentMonth)}-21/${currentYear}-${getTwoDigits(currentMonth+1)}-20`;
        }
    }
    return [prevCycle,nextCycle];
}
let getTwoDigits = function(num){
    let number = Number(num);
    if(number > 0 && number < 10 ){
        return '0' + number;
    }else {
        return number
    }
}
export { 
    currentAssessDate,
    computeAssessDate
}